module.exports = __webpack_public_path__ + "img/factory-icon.10d68943.svg";